import { ITemplatesApiClient, Templates } from "./ITemplatesApiClient";

export class EmptyTemplatesApiClient implements ITemplatesApiClient {
    public deleteTemplate(): Promise<void> {
        throw new Error("NotSupported");
    }

    public getTemplates(): Promise<Templates> {
        throw new Error("NotSupported");
    }

    public loadTemplate(): Promise<void> {
        throw new Error("NotSupported");
    }

    public renameTemplate(): Promise<void> {
        throw new Error("NotSupported");
    }

    public saveTemplate(): Promise<void> {
        throw new Error("NotSupported");
    }
}
